<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";

export default {
    mixins: [apibtoast, apigeneric, appConfig],
    page: {
        title: "Talep",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: {
        Loader,
        Layout,
        PageHeader,
    },
    data() {
        return {
            title: this.$t("FakulteYonetimKurulu.Title"),
            items: [
                {
                    text: this.$t("FakulteYonetimKurulu.Page.Anasayfa"),
                    href: "/",
                },
                {
                    text: this.$t("FakulteYonetimKurulu.Page.UstMenu"),
                    active: true,
                },
                {
                    text: this.$t("FakulteYonetimKurulu.Title"),
                    active: true,
                },
            ],

            DefaultPage: 1,
            Page: {
                PageNumber: "1",
                PageSize: "9",
                PageDataSize: "1",
            },
            TableData: {},
            currentUrl: null

        };
    },
    created() {
    this.currentUrl = window.location.host;
    },
    methods: {
        Get() {
            this.ActionsFilterGet({
                Service: "AkademikPersonel",
                Page: this.Page,
                Filter: "&Siteurl=http://" + this.currentUrl
            }).then((res) => {
                this.TableData = res.Data
                this.Page.PageDataSize = res.TotalCount;
            });
        },
    },
};
</script>
    
<template>
    <Loader>
        <Layout>
            <PageHeader :title="title" :items="items" />

            <div v-for="(Data,index) in TableData" :key="index">
                <div class="row mt-5 mb-3">
                    <div id="card" class="card bg-dark text-light text-center" style="box-shadow: 5px 5px 5px #888888; width: 300px; margin-right:11px ">
                        <div>
                            <img v-if="Data.Foto" class="card-img-top mt-2" :src="$config.FILES_URL + 'web/' + Data.Foto"
                                alt="Personel image" style="width:100%; border-radius:10px">
                            <img v-if="Data.Foto==null" class="card-img-top mt-2"
                                src="@/assets/images/personelicon.png" alt="Personel image"
                                style="width:100%; border-radius:10px">
                        </div>
                        <div class="card-body">
                            <h4 class="card-title text-light xs">{{ Data.AdSoyad }}</h4>
                            <p class="card-text">{{Data.Mail}}</p>
                        </div>
                    </div>
                </div>
                <hr>
            </div>
        </Layout>
    </Loader>
</template>